import { Action, Reducer } from "redux";
import { StatusRegisterState, StatusRegisterTypes, StatusRegisterActionTypes } from "./statusRegisterTypes";

export const INITIAL_STATE: StatusRegisterState = {
	statusRegister: {
		data: null,
		errorMessages: null,
		isError: false,
		isLoading: false,
	},
};

const statusRegisterReducer: Reducer<StatusRegisterState> = (
	state: StatusRegisterState = INITIAL_STATE,
	action: Action,
) => {
	const actionTypes = action as StatusRegisterActionTypes;
	switch (actionTypes.type) {
		case StatusRegisterTypes.GET_STATUS_REGISTER:
			return {
				...state,
				statusRegister: { ...state.statusRegister, isLoading: true },
			};
		case StatusRegisterTypes.SAVE_STATUS_REGISTER:
			return {
				...state,
				statusRegister: {
					...state.statusRegister,
					isLoading: false,
					errorMessages: actionTypes.payload.errorMessages,
					isError: actionTypes.payload.isError,
					data: actionTypes.payload.data,
				},
			};
		case StatusRegisterTypes.RESET_REDUCER_STATUS_REGISTER:
			return {
				...state,
				statusRegister: INITIAL_STATE.statusRegister,
			};
		default:
			return state;
	}
};

export default statusRegisterReducer;
